import { combineReducers } from 'redux'
import homeindexReducer from './homeIndexReducer'

const rootReducer = combineReducers({
    homeindex: homeindexReducer,
})


export default rootReducer;